import { render, staticRenderFns } from "./addTags.vue?vue&type=template&id=f98d3cea&scoped=true&"
import script from "./addTags.vue?vue&type=script&lang=js&"
export * from "./addTags.vue?vue&type=script&lang=js&"
import style0 from "./addTags.vue?vue&type=style&index=0&id=f98d3cea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f98d3cea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f98d3cea')) {
      api.createRecord('f98d3cea', component.options)
    } else {
      api.reload('f98d3cea', component.options)
    }
    module.hot.accept("./addTags.vue?vue&type=template&id=f98d3cea&scoped=true&", function () {
      api.rerender('f98d3cea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/group/components/addTags.vue"
export default component.exports